<template>
  <Modal
    :show="isModalOpen"
    body-class="atb-border-none"
    @onModalClose="changeModalVisibility"
  >
    <template #body>
      <div id="entity">
        <div class="atb-flex atb-flex-row atb-gap-4 atb-pt-6 atb-px-4 atb-pb-4">
          <div class="atb-flex-grow">
            <span> {{ getUsedByInfo }} </span>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
  import { computed, toRefs } from 'vue';
  import { useModal } from '@/app/shared/hooks/use-modal';
  import Modal from '@atb-ui/eds-vue/src/components/Modal.vue';

  interface DependencyProps {
    whereUsedData: Array<any>;
  }
  const props = defineProps<DependencyProps>();
  const { isModalOpen, changeModalVisibility } = useModal();

  const { whereUsedData } = toRefs(props);

  const getUsedByInfo = computed(() => {
    let message = 'In Use By : ';
    whereUsedData.value.forEach((element: any, index: number) => {
      message += `${element.shortName}${
        index === whereUsedData.value.length - 1 ? '' : ', '
      }`;
    });

    return message.replace(/,$/, '');
  });

  defineExpose({
    changeModalVisibility,
  });
</script>
